import { Col, Row } from '@rematter/ui-web';
import { cn } from '@rematter/ui-web';

import { FilesEventDetail } from './FilesEventDetail';
import { FilesEventsList } from './FilesEventsList';
import { FilesEventsSidebar } from './FilesEventsSidebar';

import { useFilesAuditTab } from '@/audit-log/_state/filesEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

export const FilesEventsView = () => {
  const t = useTranslations();
  const [tab, setTab] = useFilesAuditTab();

  return (
    <Col className="@FilesEventsView size-full">
      <Row className="border-b border-neutral/10 px-4">
        <button
          onClick={() => setTab('events')}
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'events'
              ? 'border-b-2 border-primary text-primary'
              : 'text-neutral/60 hover:text-neutral',
          )}
        >
          {t.filesEventsView.tabs.events}
        </button>
        <button
          onClick={() => setTab('inbox')}
          disabled
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'inbox'
              ? 'border-b-2 border-primary text-primary'
              : 'cursor-not-allowed text-neutral/30',
          )}
        >
          {t.filesEventsView.tabs.inbox}
        </button>
      </Row>
      <Row className="flex-1 items-stretch overflow-hidden">
        <FilesEventsSidebar />
        <FilesEventsList />
        <FilesEventDetail />
      </Row>
    </Col>
  );
};
